import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

import { commonStyles } from '../styles/styles';

const LearnerInvitationMessage = ({ classes, messageContent }) => (
  <div className={classes.messageWrapper}>
    <Typography className={classes.messageSubject}>
      {messageContent.message.data.content.name}
    </Typography>
    <Typography className={classes.messageContent}>
      {messageContent.message.data.message}
    </Typography>
  </div>
);

const styles = () => ({
  ...commonStyles,
});

LearnerInvitationMessage.propTypes = {
  classes: PropTypes.instanceOf(Object),
  messageContent: PropTypes.instanceOf(Object),
};

export default withStyles(styles)(LearnerInvitationMessage);



// WEBPACK FOOTER //
// ./src/Components/LearnerMessage.jsx